import { API_BASE_URL } from '@/config/env'
import { protectedRequest } from '@/api/protectedRequest'

export function assertCourierApi() {
  if (!API_BASE_URL) {
    throw new Error('Courier API requires VUE_APP_API_BASE_URL')
  }
}

export function courierRequest(request) {
  return protectedRequest(request)
}
